/**
 * Match Service
 *
 * AI-powered matching utilities. Currently exposes price-book-item matching
 * (used by the non-contract invoice item review dialog). Future Phase 2
 * batches may add more match endpoints under the same wrapper.
 */

import { apiPost, ApiError } from "@/lib/apiClient";

export interface MatchInvoiceItem {
  item_code: string | null;
  description: string;
  unit_price: number | null;
  discount: number | null;
}

export interface MatchPriceBookItem {
  id: string;
  itemcode: string;
  description: string;
  price: number;
  discount: number;
}

export interface MatchResult {
  price_book_item_id: string;
  item_code: string;
  description: string;
  price: number;
  discount: number;
  confidence: "high" | "medium" | "low";
  reasoning: string;
}

export interface MatchPriceBookItemResponse {
  success: boolean;
  matches: MatchResult[];
  no_match_explanation: string | null;
  error?: string;
}

export const matchPriceBookItemService = {
  async match(
    invoiceItem: MatchInvoiceItem,
    priceBookItems: MatchPriceBookItem[],
  ): Promise<MatchPriceBookItemResponse> {
    try {
      return await apiPost<MatchPriceBookItemResponse>("/api/match/price-book-item", {
        invoiceItem,
        priceBookItems,
      });
    } catch (err) {
      const message = err instanceof ApiError ? err.message : err instanceof Error ? err.message : String(err);
      return { success: false, matches: [], no_match_explanation: null, error: message };
    }
  },
};
